export default __webpack_public_path__ + "locales/ru/People.json?hash=2fa629237a91a4535ece62fde973f3c1";